import { isLinkAbsolute, formatCountryIdString } from './DataUtil';
import { Constants } from './Constants';
import Link from 'next/link';

export const renderLogin = (mobile, globalMetrics) => {
  return globalMetrics?.field_header_login_links.map((item) => {
    return (
      <Link
        href={item?.uri ? item?.uri : ''}
        key={`header-login-${item?.title || item?.uri || 'item'}`}
        passHref
      >
        <a
          target={isLinkAbsolute(item?.uri) ? '_blank' : '_self'}
          className={'a-header-link login-item'}
        >
          {item.title}
          {mobile && <img alt={'arrow-right'} src={'/images/arrow-down.png'} />}
        </a>
      </Link>
    );
  });
};

export const isSticky = (sticky) => {
  // if (window.innerWidth < 992){
  //     return
  // }

  const header = document.querySelector('header');
  const body = document.querySelector('body');
  const scrollTop = window.scrollY;

  if (scrollTop >= 85 || sticky === true) {
    header?.classList.add('sticky');
    body?.classList.add('padding-top');
  } else if (scrollTop < 1) {
    header?.classList.remove('sticky');
    body?.classList.remove('padding-top');
  }
};

export const fomratCountryHref = (item, pageTranslationPaths, host) => {
  if (item.domain) {
    return item.domain;
  }

  let langAlias = '';

  if (pageTranslationPaths) {
    pageTranslationPaths.forEach((pageTran) => {
      if (pageTran[item.langCode]) {
        langAlias = pageTran[item.langCode].startsWith('/')
          ? pageTran[item.langCode].slice(1)
          : pageTran[item.langCode];

        if (langAlias === 'home' || langAlias === '/home') {
          langAlias = '';
        }
      }
    });
  }

  const seg = getLocaleSegment(item.langCode);

  if (!langAlias) {
    return seg === DEFAULT_LOCALE ? '/' : `/${seg}`;
  }

  return seg === DEFAULT_LOCALE ? `/${langAlias}` : `/${seg}/${langAlias}`;
};

const getLocaleSegment = (langCode) => {
  const map = {
    'zh-hans': 'zh',
    'en-gb': 'en',
    kr: 'ko',
    ja: 'en',
    el: 'en',
    asia: 'en',
    at: 'de',
    ch: 'de',
    se: 'en',
    dk: 'en',
    ie: 'en',
    hr: 'en',
    be: 'en',
    nl: 'en',
  };

  return map[langCode] || langCode;
};

const DEFAULT_LOCALE = 'en';

const getDigitalRealtyUrl = (langCode) => {
  const urlMap = {
    'en-gb': Constants.uk,
    ch: Constants.ch,
    ko: Constants.kr,
    el: Constants.gr,
    'zh-hans': Constants.cn,
    asia: Constants.asia,
    at: Constants.at,
    be: Constants.be,
    dk: Constants.dk,
    fr: Constants.fr,
    de: Constants.de,
    ie: Constants.ie,
    nl: Constants.nl,
    es: Constants.es,
    se: Constants.se,
    it: Constants.it,
  };
  return urlMap[langCode] || '';
};

export const formatGlobalHref = (item, pageTranslationPaths, host) => {
  let langAlias = '';

  pageTranslationPaths?.forEach((pageTran) => {
    if (!pageTran[item.langCode]) return;

    langAlias = pageTran[item.langCode];
    if (langAlias === '/home' || langAlias === 'home') {
      langAlias = '';
    }
  });

  if (!langAlias) {
    const seg = getLocaleSegment(item.langCode);
    return seg === DEFAULT_LOCALE ? '/' : `/${seg}`;
  }

  if (langAlias.startsWith('/')) {
    langAlias = langAlias.slice(1);
  }

  const seg = getLocaleSegment(item.langCode);

  return seg === DEFAULT_LOCALE ? `/${langAlias}` : `/${seg}/${langAlias}`;
};

export const renderCountries = (
  data,
  global,
  pageTranslationPaths,
  host,
  formatIdStrings,
  languageSelectorData
) => {
  if (!data || data.length === 0) {
    return null;
  }

  // dropdown prikazujemo samo u "global" sekciji
  // if (!global) {
  //   return null;
  // }

  // 1) JEZICI – fiksni redosled i label-e kao na slici
  // const LANGUAGE_ITEMS = [
  //   { langCode: 'en', label: 'English' },
  //   { langCode: 'de', label: 'Deutsch' },
  //   { langCode: 'es', label: 'Espanol' },
  //   { langCode: 'fr', label: 'Francais' },
  //   { langCode: 'ko', label: 'Korean (한국인)' },
  //   { langCode: 'zh-hans', label: 'Simplified Chinese (中国人)' },
  // ];
  const LANGUAGE_ITEMS = languageSelectorData.map(
    ({ field_langcode_header, name }) => ({
      langCode: field_langcode_header,
      label: name,
    })
  );

  // 2) AFFILIATES – iz postojeće strukture (name: 'AFFILIATES')
  const affiliatesGroup = data.find((item) => item.name === 'AFFILIATES');
  const affiliates = affiliatesGroup?.children || [];

  const currentPath =
    typeof window !== 'undefined' ? window.location.pathname : '';

  const renderLanguageLink = (item) => {
    // koristimo formatGlobalHref da URL ostane konzistentan
    const href = formatGlobalHref(
      { langCode: item.langCode },
      pageTranslationPaths,
      host
    );

    // aktivni jezik = bold (href se poklapa sa trenutnim URL-om)
    const isActive =
      currentPath === href ||
      (href === '/' && currentPath === '') ||
      (href !== '/' && currentPath.startsWith(href));

    return (
      <a
        key={item.langCode}
        id={`language-${formatIdStrings(item.label)}-link`}
        href={href}
        className={
          'lang-item span-header-link language-item' +
          (isActive ? ' language-item--active' : '')
        }
      >
        {item.label}
      </a>
    );
  };

  const renderAffiliateLink = (item, idx) => {
    const href =
      item.domain || fomratCountryHref(item, pageTranslationPaths, host);

    return (
      <a
        key={item.id || idx}
        id={`affiliate-${formatIdStrings(item.name)}-link`}
        href={href}
        target={item.domain ? '_blank' : '_self'}
        className="lang-item span-header-link affiliate-item"
      >
        {item.name}
      </a>
    );
  };

  return (
    <div className="region" key="region-language-affiliates">
      <div className="languages-container">
        {/* JEZICI */}
        {LANGUAGE_ITEMS.map(renderLanguageLink)}

        {/* AFFILIATES NA KRAJU */}
        {affiliates.length > 0 && (
          <>
            <div className="affiliates-title">AFFILIATES</div>
            <div className="affiliates-divider" />
            {affiliates.map(renderAffiliateLink)}
          </>
        )}
      </div>
    </div>
  );
};

// ostatak funkcije (column1/column2 i region.children) OSTAVLJAŠ KAKO JESTE
// jer već koristi href={fomratCountryHref(...)} koji smo gore promenili.
// ...

export const handleRouteChange = (url) => {
  isSticky();
};

export const getHamburgerClass = (openMenu, showHamburger) => {
  if (openMenu && !showHamburger) {
    return 'hamburger hamburger--collapse is-active';
  }

  return 'hamburger hamburger--collapse';
};

export function triggerChange(showTalkForm, setShowTalkForm) {
  if (showTalkForm) {
    // let home = document.getElementsByClassName('home');
    let home = document.getElementsByTagName('main');
    if (home !== undefined && home.length > 0) {
      home[0].addEventListener('click', function () {
        setShowTalkForm(false);
      });
    }
  }
}

export const scrollUp = (lastScrollTop, setLastScrollTop) => {
  let st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
  const scrollTop = window.scrollY;
  const breadcrumb = document.getElementsByClassName('breadcrumb')[0];
  const body = document.querySelector('body');

  if (st < lastScrollTop && scrollTop >= 85) {
    breadcrumb?.classList.add('sticky');
    body?.classList.add('padding-top-breadcrumb');
  } else if (scrollTop < 1 || st > lastScrollTop) {
    breadcrumb?.classList.remove('sticky');
    body?.classList.remove('padding-top-breadcrumb');
  }

  setLastScrollTop(st <= 0 ? 0 : st); // For Mobile or negative scrolling
};

export const headerLanguageName = (languageSelectorData, lang) => {
  // const map = {
  //   en: 'English',
  //   de: 'Deutsch',
  //   es: 'Espanol',
  //   fr: 'Francais',
  //   ko: 'Korean (한국인)',
  //   'zh-hans': 'Simplified Chinese (中国人)',
  // };
  // return map[lang] || 'English'; // default ako nešto fali

  return (
    languageSelectorData.find((t) => t.field_langcode_header === lang)?.name ||
    'English'
  );
};

export const headerLanguageImage = (countryData, lang) => {
  const languageImageMap = {
    'en-gb': 'uk.png',
    ko: 'korea.png',
    ja: 'japan.png',
    'zh-hans': 'china.png',
    el: 'greece.png',
    // Add more mappings as needed
  };

  if (lang in languageImageMap) {
    return languageImageMap[lang];
  }

  // If the language code is not found in the map, return the flag code
  let flagCode = '';
  countryData.forEach((item) => {
    if (item.langCode === lang) {
      flagCode = item.flagCode;
    }
  });
  return flagCode;
};
